import { useState } from "react";
import { useEffect } from "react";
import cover from "../../assets/cover.png";
const CountDownTimer = (props) => {
  var [countDown, setCountDown] = useState(3);
  useEffect(() => {
    if (countDown > 0) {
      setTimeout(() => {
        setCountDown(countDown - 1);
      }, 500);
    }
  }, [countDown]);
  let coverImage = cover;
  if (countDown === 0) {
    countDown = "Let's Go";
    coverImage = "";
  }
  return (
    <div
      style={{
        position: "absolute",
        width: props.width,
        height: props.height,
        color: "white",
        fontSize: "large",
        fontWeight: "800",
        zIndex: 2,
      }}
      className="d-flex justify-content-center align-items-center"
    >
      <img src={coverImage} style={{ position: "absolute" }}></img>
      <div
        style={{
          color: "white",
          fontSize: "6em",
          fontWeight: "700",
          position: "absolute",
        }}
        className="text"
      >
        {countDown}
      </div>
    </div>
  );
};

export default CountDownTimer;
